import $ from 'jquery';
import moment from 'moment';
import solarLunar from 'solarlunar';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import 'next/stylesheets/components/calendar-container.scss';

Component('tr-calendar-container', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    addTodoUrl: String,
    projectGuid: String,
  },

  connected() {
    this.date = moment();
    this.month = this.date.format('YYYY-MM');
    this.calendarData = {};
    this.dialogPage = this.querySelector('tr-dialog-page');

    $('.calendar-title').text(this.date.format('YYYY 年 M 月'));

    this.initCalendar(this.month);
    this.setDateInCalendar(this.date.year(), this.date.month() + 1);
    this.fetchData(this.date.year(), this.date.month() + 1);
    this.addEventListeners();
  },

  addEventListeners() {
    this.calendar.on('todorender', this.handleTodoRender.bind(this));
    this.calendar.on('eventrender', this.handleEventRender.bind(this));
    this.calendar.on('todoclick', this.handleTodoClick.bind(this));
    this.calendar.on('addtodosclick', this.handleAddTodosClick.bind(this));
    this.calendar.on('daydblclick', this.handleAddTodosClick.bind(this));
    this.calendar.on('todomouseenter', (e, todo) => { $(`.todo[data-id=${todo.id}]`).addClass('hover'); });
    this.calendar.on('todomouseleave', (e, todo) => { $(`.todo[data-id=${todo.id}]`).removeClass('hover'); });
    this.calendar.on('tododrop', this.handleTodoDrop.bind(this));
    this.calendar.on('todocomplete', this.handleTodocomplete.bind(this));
    this.listenTo(this.querySelector('.nav-button'), 'click', this.handleNavBtnClick.bind(this));
    this.listenTo(this, 'tr-calendar-todo-form:addTodoSuccess', this.handleAddTodoSuccess.bind(this));
    this.listenTo(this, 'tr-calendar-setting-bar:change', this.handleSettingsChange.bind(this));
    this.todoSubscription = resourceSubject('todo').subscribe({
      next: this.syncTodos.bind(this),
    });

    if (/Mac/.test(navigator.userAgent)) {
      this.listenTo(this, 'contextmenu', (e) => { e.preventDefault(); });
    }
  },

  setDateInCalendar(year, month) {
    const calendar = this.querySelector('#calendar');
    calendar.setAttribute('data-year', year);
    calendar.setAttribute('data-month', month);
  },

  handleTodocomplete(e, todo) {
    const { completed, id } = todo;
    $('.simple-tooltip').remove();
    const url = `/projects/${this.projectGuid}/todos/${id}/${completed ? 'complete' : 'reopen'}`;
    $.ajax({
      url,
      type: 'post',
      dataType: 'json',
    }).then((result) => {
      const { todo: newTodo } = result;
      this.calendar.replaceTodo(newTodo);
    });
  },

  handleSettingsChange(event) {
    const { target, value = '' } = event.detail;
    switch (target) {
      case 'avatar':
        $('#calendar').toggleClass('calendar-hide-avatars');
        break;
      case 'lunarCalendar':
        $('#calendar').toggleClass('calendar-show-lunar-calendar');
        break;
      case 'holidays':
        $('#calendar').toggleClass('calendar-show-holidays');
        break;
      case 'color':
        this.toggleColorClass(value);
        break;
      default:
        break;
    }
  },

  toggleColorClass(color) {
    switch (color) {
      case 'field':
        $('#calendar').removeClass('calendar-show-default-color calendar-show-priority-color');
        $('#calendar').addClass('calendar-show-field-color');
        break;
      case 'default':
        $('#calendar').removeClass('calendar-show-field-color calendar-show-priority-color');
        $('#calendar').addClass('calendar-show-default-color');
        break;
      case 'priority':
        $('#calendar').removeClass('calendar-show-default-color calendar-show-field-color');
        $('#calendar').addClass('calendar-show-priority-color');
        break;
      default:
        break;
    }
  },

  handleTodoDrop(e, todo) {
    const date = `${todo.start.format('YYYY-MM-DD')},${todo.end.format('YYYY-MM-DD')}`;
    $.ajax({
      url: `/projects/${this.projectGuid}/calendar/todos/${todo.id}`,
      type: 'patch',
      data: {
        'todos_management[due_date]': date,
      },
      dataType: 'json',
    });
  },

  syncTodos(event, todo) {
    if (!todo.guid) return;

    if (event === 'update' || event === 'update:pusher') {
      if (todo.updateOnCalendar) {
        const { todo: newTodo } = todo.rowData;
        this.calendar.replaceTodo(newTodo);
      }
    } else if (event === 'destroy') {
      this.calendar.removeTodo({
        guid: todo.guid,
      });
    }
  },

  handleAddTodoSuccess(event) {
    const { todo } = event.detail;
    this.calendar.addTodo(todo);
  },

  handleAddTodosClick(e, $day) {
    const date = $day.data('date');
    $.ajax({
      url: this.addTodoUrl,
      method: 'GET',
      dataType: 'script',
      data: {
        date,
      },
    });
  },

  handleNavBtnClick(event) {
    let { date } = this;
    if (closest(event.target, '.btn-prev-month')) {
      date = date.clone().subtract(1, 'month');
    } else if (closest(event.target, '.btn-next-month')) {
      date = date.clone().add(1, 'month');
    } else if (closest(event.target, '.btn-today')) {
      date = moment();
    }

    this.setDateInCalendar(date.year(), date.month() + 1);
    this.fetchData(date.year(), date.month() + 1);
  },

  initCalendar(month) {
    this.calendar = window.simple.calendar({
      el: this.querySelector('#calendar'),
      month,
      timezone: $('#member-timezone').val() || 'Asia/Shanghai',
      todoKeys: {
        id: 'guid',
        start: 'start_at',
        end: 'due_at',
        completed: 'completed',
        content: 'content',
      },
      onDayRender: this.renderOnDay.bind(this),
      allowDrag: 'all',
    });
  },

  renderOnDay(date, el) {
    const year = date.year();
    const month = date.month() + 1;
    const day = date.date();
    const cnDay = solarLunar.solar2lunar(year, month, day).dayCn;

    $(el).find('.info .num').after(`<span class='cn-day'>${cnDay}</span>`);
    this.renderHolidays(date, el);
    const addTodos = el.get(0).querySelector('.info .add-todos');
    addTodos.setAttribute('data-tooltip', '新建任务');
    addTodos.setAttribute('data-position', 'top');
  },

  renderHolidays(date, el) {
    const holidays = $('#calendar').data('holidays');
    holidays.forEach((item) => {
      if (moment(date).isBetween(moment(item.starts_at), moment(item.ends_at), null, [])) {
        $(el).find('.info .cn-day').after(`<span class='holiday'>${item.content}</span>`);
      }
    });
  },

  fetchData(year, month) {
    if (!this.calendar) return;

    if (this.fetchRequest) {
      this.fetchRequest.abort();
      this.fetchRequest = null;
    }

    this.fetchRequest = $.ajax({
      type: 'get',
      url: this.url,
      data: {
        year,
        month,
      },
    }).done((result) => {
      this.calendarData[month] = {
        todos: result.todos,
      };
      this.date = moment().year(year).month(month - 1);
      $('.calendar-title').text(this.date.format('YYYY 年 M 月'));
      this.calendar.setMonth(this.date.format('YYYY-MM'));
      this.renderEventsAndTodos(month);
    });
  },

  renderEventsAndTodos(month) {
    if (!this.calendar) return;
    const data = this.calendarData[month];
    if (!data) return;

    this.calendar.clearTodos();
    this.calendar.addTodo(data.todos);
  },

  handleTodoRender(e, todo, $todo) {
    // eslint-disable-next-line camelcase
    const { assignee_guid, priority, field_color: fieldColor } = todo.origin;
    if (!$todo.hasClass('completed')) {
      const checkbox = $todo.get(0).querySelector('.todo-wrapper .cb-done');
      checkbox.setAttribute('data-tooltip', '完成任务');
      checkbox.setAttribute('data-position', 'top');
    }
    $todo.addClass(`${priority}`);
    if (fieldColor) {
      $todo.addClass(`${fieldColor}`);
    }
    $todo.attr('data-assignee-guid', assignee_guid);
    this.renderTodoMember(todo, $todo.find('.content'));
  },

  handleEventRender(e, event, $event) {
    if (event.origin.is_todo) {
      if (!$event.hasClass('completed')) {
        const checkbox = $event.get(0).querySelector('.todo-wrapper .cb-done');
        checkbox.setAttribute('data-tooltip', '完成任务');
        checkbox.setAttribute('data-position', 'top');
      }
      const $content = $event.find('.content');
      this.renderTodoMember(event, $content);
      $event.addClass(`${event.origin.priority}`);
      if (event.origin.field_color) {
        $event.addClass(`${event.origin.field_color}`);
      }
    }
  },

  handleTodoClick(e, todo) {
    const { id } = todo;
    const detailUrl = `/projects/${this.projectGuid}/todos/${id}`;
    this.dialogPage.requestPage(detailUrl);
  },

  renderTodoMember(todo, $content) {
    const { origin } = todo;
    if (origin.assignee_avatar && origin.assignee_nickname) {
      const ele = `<span class="members">
        <img class="avatar" src="${origin.assignee_avatar}" alt="${origin.assignee_nickname}" title="${origin.assignee_nickname}">
      </span>`;
      $content.prepend(ele);
    }
  },

  disconnected() {
    this.stopListening();
    if (this.todoSubscription) this.todoSubscription.unsubscribe();
  },
});
